<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="平台类型" prop="platformType">
                <a-select v-model="queryParam.platformType" placeholder="请输入" allow-clear>
                  <a-select-option :value="1">微信</a-select-option>
                  <a-select-option :value="2">抖音</a-select-option>
                  <a-select-option :value="3">支付宝</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="岗位名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="公司名称" prop="companyName">
                <a-input v-model="queryParam.companyName" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="负责部门" prop="chargePost">
                <a-tree-select
                  v-model="queryParam.chargePost"
                  style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :tree-data="postOptions"
                  placeholder="请选择"
                  :replaceFields="{ children: 'children', title: 'postName', key: 'id', value: 'id' }"
                  tree-default-expand-all
                >
                </a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:companyPost:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:companyPost:export']">
          <a-icon type="download" />导出
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:companyPost:remove']">
          <a-icon type="delete" />批量删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 2600}"
      >
        <span slot="expiryDate" slot-scope="text, record">
          {{ parseTime(record.expiryDate) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="status" slot-scope="text, record">
          <div>
            <a-switch @click="updateStatus(record)" v-model="record.status == 1">
              <a-icon type="check" slot="checkedChildren"/>
              <a-icon type="close" slot="unCheckedChildren"/>
            </a-switch>
          </div>
        </span>
        <span slot="isSyncZfb" slot-scope="text, record">
          <div>
            <a-switch @click="updateSyncZfb(record)" v-model="record.isSyncZfb == 1">
              <a-icon type="check" slot="checkedChildren"/>
              <a-icon type="close" slot="unCheckedChildren"/>
            </a-switch>
          </div>
        </span>
        <span slot="platformType" slot-scope="text, record">
          <a-tag v-for="(platform) in record.platformType.split(',')" color="blue">
            {{ platform === '1' ? '微信' : platform === '2' ? '抖音' : '支付宝' }}
          </a-tag>
        </span>
        <span slot="wage" slot-scope="text, record">
          <div v-if="record.wageType === 1">
            {{ record.minWage }}-{{ record.maxWage }}元
          </div>
          <div v-if="record.wageType === 2">
            {{ record.minWage }}元
          </div>
          <div v-if="record.wageType === 3">
            {{ record.minWage }}
          </div>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:companyPost:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:companyPost:edit']">
            <a-icon type="edit" />查看/编辑
          </a>
          <a-divider type="vertical" v-hasPermi="['user:companyPost:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:companyPost:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCompany, delCompany, updateCompany, syncZfb } from '@/api/user/companyPost'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
const {queryPostList} = require("@/api/system/post");

export default {
  name: 'Company',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      postOptions: [],
      // 查询参数
      queryParam: {
        companyId: null,
        chargePost: null,
        companyName: null,
        platformType: null,
        name: null,
        precinctId: null,
        workId: null,
        isHot: null,
        wageType: null,
        wage: null,
        clearingForm: null,
        commission: null,
        expiryDate: null,
        minAge: null,
        maxAge: null,
        sex: null,
        recruitNum: null,
        explain: null,
        tagIds: null,
        description: null,
        sort: null,
        cateName: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '岗位ID',
          dataIndex: 'id',
          width: 120,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '岗位名称',
          dataIndex: 'name',
          width: 120,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '公司名称',
          dataIndex: 'companyName',
          width: 120,
          align: 'center'
        },
        {
          title: '负责部门',
          dataIndex: 'chargePostName',
          width: 120,
          align: 'center'
        },
        {
          title: '平台类型',
          dataIndex: 'platformType',
          scopedSlots: { customRender: 'platformType' },
          width: 180,
          align: 'center'
        },
        {
          title: '职位工资',
          dataIndex: 'wage',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'wage' }
        },
        {
          title: '岗位专区',
          dataIndex: 'postPrecinctName',
          width: 120,
          align: 'center'
        },
        {
          title: '工种类别',
          dataIndex: 'workTypeName',
          width: 120,
          align: 'center'
        },
        {
          title: '报名人数',
          dataIndex: 'applyUserNum',
          width: 120,
          align: 'center'
        },
        {
          title: '累计入职人数',
          dataIndex: 'totalUserNum',
          width: 120,
          align: 'center'
        },
        {
          title: '浏览次数',
          dataIndex: 'browseNum',
          width: 120,
          align: 'center'
        },
        {
          title: '在职员工数量',
          dataIndex: 'useUserNum',
          width: 120,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '是否同步支付宝人才市场',
          dataIndex: 'isSyncZfb',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'isSyncZfb' }
        },
        {
          title: '排序',
          dataIndex: 'sort',
          width: 120,
          align: 'center'
        },
        {
          title: '学历',
          dataIndex: 'education',
          width: 120,
          align: 'center',
          customRender: function (education) {
            if (education == 1) {
              return '大专'
            } else if (education == 2) {
              return '本科'
            } else if (education == 3) {
              return '硕士'
            } else if (education == 4) {
              return '博士'
            } else if (education == 5) {
              return '不要求'
            }
          }
        },
        {
          title: '工作经验',
          dataIndex: 'workExperience',
          width: 120,
          align: 'center',
          customRender: function (workExperience) {
            if (workExperience == 1) {
              return '应届毕业生'
            } else if (workExperience == 2) {
              return '3年及以下'
            } else if (workExperience == 3) {
              return '3-5年'
            } else if (workExperience == 4) {
              return '5-10年'
            } else if (workExperience == 5) {
              return '10年以上'
            } else if (workExperience == 6) {
              return '经验不限'
            }
          }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 240,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.queryPostList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    queryPostList() {
      queryPostList().then(response => {
        this.postOptions = response.data
      })
    },
    updateStatus(record) {
      // 更改状态
      record.status = (record.status == 0) ? 1 : 0
      updateCompany(record).then(response => {
        this.$message.success(
          '修改成功',
          3
        )
        this.$emit('ok')
      }).finally(() => {
        this.getList()
      })
    },
    updateSyncZfb(record) {
      record.isSyncZfb = (record.isSyncZfb == 0) ? 1 : 0
      syncZfb(record).then(response => {
        this.$message.success(
          '同步成功',
          3
        )
        this.$emit('ok')
      }).finally(() => {
        this.getList()
      })
    },
    /** 查询公司岗位列表 */
    getList () {
      this.loading = true
     pageCompany(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        companyId: undefined,
        name: undefined,
        precinctId: undefined,
        workId: undefined,
        isHot: undefined,
        wageType: undefined,
        wage: undefined,
        clearingForm: undefined,
        commission: undefined,
        expiryDate: undefined,
        minAge: undefined,
        maxAge: undefined,
        sex: undefined,
        recruitNum: undefined,
        explain: undefined,
        tagIds: undefined,
        description: undefined,
        sort: undefined,
        cateName: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delCompany(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/company-post/export', {
            ...that.queryParam
          }, `公司岗位_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
